import * as React from "react";
import {
  ThemeProvider,
  createTheme,
  responsiveFontSizes,
} from "@mui/material/styles";
import type { ThemeOptions } from "@mui/material/styles";
import { inputsCustomisations } from "./customisations/inputs";
import { dataDisplayCustomisations } from "./customisations/dataDisplay";
import { feedbackCustomisations } from "./customisations/feedback";
import { navigationCustomisations } from "./customisations/navigation";
import { surfacesCustomisations } from "./customisations/surfaces";
import { typography, shadows, shape } from "./themePrimitives";
import { useCustomisation } from "../context/CustomisationContext";

interface AppThemeProps {
  children: React.ReactNode;
  /**
   * This is for the docs site. You can ignore it or remove it.
   */
  disableCustomTheme?: boolean;
  themeComponents?: ThemeOptions["components"];
  // customTheme: Theme;
}

export default function AppTheme(props: AppThemeProps) {
  const { children, disableCustomTheme, themeComponents } = props;
  const { customisations: customTheme } = useCustomisation();
  const theme = React.useMemo(() => {
    if (disableCustomTheme) return {};
    let baseTheme = createTheme({
      // For more details about CSS variables configuration, see https://mui.com/material-ui/Customisation/css-theme-variables/configuration/
      // cssVariables: {
      //   colorSchemeSelector: "data-mui-color-scheme",
      //   cssVarPrefix: "template",
      // },
      // colorSchemes, // Recently added in v6 for building light & dark mode app, see https://mui.com/material-ui/Customisation/palette/#color-schemes
      breakpoints: {
        values: {
          xs: 0, // Mobile
          sm: 481, // Tablet
          md: 1025, // Standard
          lg: 1441, // Monitor
          xl: 1920, // Extra large
        },
      },
      typography,
      shadows,
      shape,
      components: {
        ...inputsCustomisations(customTheme),
        ...dataDisplayCustomisations(customTheme),
        ...feedbackCustomisations(customTheme),
        ...navigationCustomisations(customTheme),
        ...surfacesCustomisations(customTheme),
        ...themeComponents,
      },
    });
    return responsiveFontSizes(baseTheme);
  }, [disableCustomTheme, themeComponents, customTheme]);
  if (disableCustomTheme) {
    return <React.Fragment>{children}</React.Fragment>;
  }
  return (
    <ThemeProvider theme={theme} disableTransitionOnChange>
      {children}
    </ThemeProvider>
  );
}
